import React from 'react';
import { FaBuilding, FaCalendarAlt, FaUsers, FaEnvelope, FaMapMarkerAlt, FaCheckCircle } from 'react-icons/fa';

const About = () => {
  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">About VALARCCI FOUNDATION</h1>
          <p className="text-xl text-black">Empowering Communities Through Health and Care</p>
        </div>

        <div className="bg-gradient-to-r from-[#eecda3] to-[#6dd5ed] rounded-lg p-8 shadow-xl space-y-8">
          {/* Company Overview */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaBuilding className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Company Overview</h2>
            </div>
            <p className="text-black">
              VALARCCI FOUNDATION (CIN: U85100HR2021NPL097932) is a Private company incorporated on 25 Dec 2021. 
              It is classified as Non-government company and is registered at Registrar of Companies, Delhi. 
              Its authorized share capital is Rs. 100000.00 and its paid up capital is Rs. 100000.00.
            </p>
          </div>

          {/* Company Status */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaCheckCircle className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Current Status</h2>
            </div>
            <p className="text-black">
              Current status of VALARCCI FOUNDATION is - Active.
            </p>
          </div>

          {/* Business Details */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaCalendarAlt className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Business Details</h2>
            </div>
            <div className="text-black space-y-2">
              <p>NIC Code: 851 (Human health activities)</p>
              <p>Registration Number: 97932</p>
              <p>Last AGM: 01 Dec 0001</p>
              <p>Last Balance Sheet Filed: 0001-01-01</p>
            </div>
          </div>

          {/* Directors */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaUsers className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Directors</h2>
            </div>
            <div className="text-black">
              <p>PUSHPA</p>
              <p>VIKASH KUMAR</p>
              <p>SUSHIL KUMAR</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaEnvelope className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Contact Information</h2>
            </div>
            <div className="text-black space-y-2">
              <p>Email: director@valarccifoundation.co.in</p>
            </div>
          </div>

          {/* Address */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <FaMapMarkerAlt className="text-blue-400 text-2xl" />
              <h2 className="text-2xl font-bold text-blue-400">Registered Address</h2>
            </div>
            <div className="text-black">
              <p>C/o Sushil Kumar Near Water Works Dhobi Road,</p>
              <p>Banda Heri, Hisar, Haryana, India - 125001</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 